import { createAction } from '@reduxjs/toolkit';
import { IResourceSkill } from '../../../../dto';
import { ACT_SET, MN_RESOURCE_SKILLS, TYPE_ELEMENT } from '../../../../common';

export const setResourceSkill = createAction<IResourceSkill>(
  `${MN_RESOURCE_SKILLS}/${TYPE_ELEMENT}/${ACT_SET}`,
);
